import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=187eb080&scoped=true&"
import script from "./login-card.vue?vue&type=script&lang=js&"
export * from "./login-card.vue?vue&type=script&lang=js&"
import style0 from "./login-card.vue?vue&type=style&index=0&id=187eb080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187eb080",
  null
  
)

export default component.exports